import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaChalkboardTeacher, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { BsCalendarDate } from 'react-icons/bs';
import { UserContext } from '../../context/UserContext';
import { ClockLoader } from 'react-spinners';
import { TbSchool } from 'react-icons/tb';
import { BsInfoCircle } from "react-icons/bs";
import { Tooltip } from 'react-tooltip'


function EnrollScreen() {
  const navigate = useNavigate();
  const [initialClasses, setInitialClasses] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cookies] = useCookies();
  const {logOutFunction, userProfile} = useContext(UserContext);
  const {setTostMessage} = useContext(TostMessageContext);
  const [searchParams, setSearchParams] = useState({'timezone': '', 'language': '', 'class_type': ''});
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [selectedCount, setCount] = useState(0);
  const [canProceed, setCanProceed] = useState(false);

  useEffect(() => {
    getClasses();
  }, [])

  const search = async () => {
    getClasses();
  }
  useEffect(() => {
    search();
    setSelectedClasses([]);
  }, [searchParams])

  const getClasses = async () => {
    setLoading(true);
    try {
        const response = await axios.get(base_url + '/enroll/fetch-classes.php?timezone=' + searchParams?.timezone + '&language=' + searchParams?.language + '&class_type=' + searchParams?.class_type, {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                main_id: cookies?.userProfile?.main_id,
                sub_id: cookies?.userProfile?.sub_id
            },
        });
        if (response.data.code == 403) {
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
            logOutFunction()
        }
        if (response.data.status) {
            setLoading(false);
            if (response.data.results) {
              setInitialClasses(response.data.results);
            } else {
              setInitialClasses(null);
            }
        } else {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
        }
    } catch (error) {
        setLoading(false);
        setTostMessage({
            messageType: "error",
            message: 'Network error',
        });
    }
  }

  const selectNewClass = async (group_id, isSelected, language, schedule, level_name, amount, plan_id, start_date, end_date) => {
    const new_array = selectedClasses;
    if (isSelected) {
      new_array.push({'group_id': group_id, 'language': language, 'level_name': level_name, 'schedule': schedule, 'amount': amount, 'plan_id': plan_id, 'duration': 1, 'start_date': start_date, 'end_date': end_date})
      setCanProceed(true);
      setCount(selectedCount+1);
    } else {
      new_array.splice(new_array.indexOf(group_id), 1);
      setCount(selectedCount-1);
      if (new_array.length < 1) {
        setCanProceed(false)
      }
    }
    setSelectedClasses(new_array)
  } 

  const selectPrivateClass = async (isSelected, language, schedule, level_name, amount, booking_id) => {
    const new_array = selectedClasses;
    if (isSelected) {
      new_array.push({'booking_id': booking_id, 'language': language, 'level_name': level_name, 'schedule': schedule, 'amount': amount, 'duration': 1})
      setCanProceed(true);
      setCount(selectedCount+1);
    } else {
      new_array.splice(new_array.indexOf(booking_id), 1);
      setCount(selectedCount-1);
      if (new_array.length < 1) {
        setCanProceed(false)
      }
    }
    setSelectedClasses(new_array)
  } 

  const light_colors = ["bg-blue-100", "bg-pink-100", "bg-yellow-light"];
  const deep_colors = ["bg-blue-700", "bg-pink-600", "bg-gold"];
  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <Tooltip id="my-tooltip" />
                <div className='flex flex-row justify-between'>
                    <div className="w-full">
                      <div className='flex flex-row items-center gap-x-3 mb-6'>
                        <h2 className="text-xl font-semibold">{searchParams?.class_type == "private_class" ? 'Book a Private Class' : 'Join a Group Class'}</h2>
                        <a data-tooltip-id="my-tooltip" data-tooltip-content={`Only group classes accessible to ${userProfile?.sub_name}'s age group or without age restrictions will be displayed.`}>
                          <BsInfoCircle />
                        </a>
                      </div>
                      {/* Filter section */}
                      <div className="flex flex-wrap justify-between items-center mb-6">
                        <div className="flex gap-4 flex-wrap">
                          <div className="flex flex-col items-start gap-4 mt-4 md:mt-0">
                            <span className="text-sm text-dark font-semibold">
                              Class Type
                            </span>
                            <select onChange={(e) => setSearchParams({...searchParams, class_type: e.target.value})} className="border h-12 px-2 lg:px-4 py-1 lg:py-2 rounded-md text-sm text-dark w-[8rem] font-semibold lg:w-52">
                              <option value="group_class">Group Class</option>
                              <option value="private_class">Private Class</option>
                            </select>
                          </div>
                          <div className="flex flex-col items-start gap-4 mt-4 md:mt-0">
                            <span className="text-sm text-gray-700">
                              Select Language
                            </span>
                            <select onChange={(e) => setSearchParams({...searchParams, language: e.target.value})} className="border h-12 px-2 lg:px-4 py-1 lg:py-2 rounded-md text-sm text-gray-700 w-[8rem] lg:w-52">
                              <option value="">All Languages</option>
                              {userProfile?.misc?.language?.map((lang, index) => 
                                <option value={lang.language_id}>{lang.language}</option>
                              )}
                            </select>
                          </div>
                          <div className="flex flex-col items-start gap-4 mt-4 md:mt-0">
                            <span className="text-sm text-gray-700">
                              Select Timezone
                            </span>
                            <select onChange={(e) => setSearchParams({...searchParams, timezone: e.target.value})} className="border h-12 px-2 lg:px-4 py-1 lg:py-2 rounded-md text-sm text-gray-700 w-[8rem] lg:w-52">
                              <option value="">Default</option>
                              {userProfile?.misc?.timezones?.map((tz, index) => 
                                <option value={tz.tz_id}>{tz.tz_name}</option>
                              )}
                            </select>
                          </div>
                        </div>
                        <div className="flex w-full lg:w-auto flex-row lg:flex-col items-center lg:items-end justify-between gap-4 mt-4 md:mt-0">
                          <span className="text-sm text-gray-700">
                            {selectedCount} Language(s) Selected
                          </span>
                          <button onClick={() => navigate(searchParams?.class_type == 'private_class' ? '/enroll/confirm-private-enrollment' : '/enroll/confirm-enrollment', { state: { classes: selectedClasses} })} className={`bg-yellow px-6 py-2 rounded-md font-medium text-sm ${!canProceed && 'opacity-[0.7]'}`}>
                            Continue
                          </button>
                        </div>
                      </div>

                      {/* Grid of class cards */}
                      {loading ? (
                        <div className='w-max mt-[20%] flex justify-center items-center mx-auto my-auto'>
                            <ClockLoader
                                color={'#212121'}
                                loading={loading}
                                size={25}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                        </div>
                      ) : (
                      <div>
                      {initialClasses?.length > 0 ?
                      (
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                        {initialClasses?.map((cls, index) => {
                          if (searchParams?.class_type !== "private_class") {
                            return (
                              <div
                                className={`relative p-6 rounded-[15px] ${cls?.theme?.background} w-full max-w-sm`}
                              >
                                <div className="absolute my-2 top-3 right-3">
                                  {cls.enrolled ? (
                                    <a className='text-[#00b47a] text-sm'>Enrolled</a>
                                  ) : (
                                    <div className='flex flex-row gap-x-2 items-center'>
                                      <p className="text-sm text-gray-900 font-semibold">
                                        {cls?.currency}{cls?.amount} <span className="font-normal text-xs">/ mo</span>
                                      </p>
                                      <input
                                        type="checkbox"
                                        // checked={'selected'}
                                        onChange={(e) => selectNewClass(cls.group_id, e.target.checked, cls.language, cls.schedule, cls.level_name, cls.amount, cls.plan_id, cls.start_date, cls.end_date)}
                                        className="w-4 h-4 accent-orange text-white"
                                      />
                                    </div>
                                  )}
                                </div>

                                <h3 className="text-sm my-2 font-semibold text-gray-800 mb-2">
                                  {cls?.language} ({cls?.level_name})
                                </h3>
                                <div className="flex my-2 items-center text-sm text-gray-700 mb-1">
                                  <FaChalkboardTeacher className="mr-2 text-xs" />
                                  {cls?.tutor}
                                </div>
                                <div className="flex my-2 items-center text-sm text-gray-700 mb-1">
                                    <TbSchool className="mr-2 text-xs" />
                                    <span>Group #{cls.group_id}</span>
                                </div>
                                <div className="flex my-2 flex-wrap gap-2 mb-3">
                                  {cls?.schedule?.map((time, idx) => (
                                    <span
                                      key={idx}
                                      className={`${cls?.theme?.chip} text-white px-3 py-1 text-xs rounded-full flex items-center`}
                                    >
                                      <BsCalendarDate className="mr-1 text-xs" />
                                      {time}
                                    </span>
                                  ))}
                                </div>
                                <div className="flex gap-x-3 flex-row my-2 items-center text-sm text-gray-700 mb-1">
                                    <span>Ages {cls.age_group}</span>
                                    <span>|</span>
                                    <span>{cls.class_period}</span>
                                </div>
                              </div>
                            ) 
                          } else {
                            return (
                              <div
                                className={`relative p-6 rounded-[15px] ${cls?.theme?.background} w-full max-w-sm`}
                              >
                                <div className="absolute my-2 top-3 right-3">
                                  <div className='flex flex-row gap-x-2 items-center'>
                                    <p className="text-sm text-gray-900 font-semibold">
                                      {cls?.currency}{cls?.amount} <span className="font-normal text-xs">/ class</span>
                                    </p>
                                    <input
                                      type="checkbox"
                                      // checked={'selected'}
                                      onChange={(e) => selectPrivateClass(e.target.checked, cls.language, cls.schedule, cls.level_name, cls.amount, cls.booking_id)}
                                      className="w-4 h-4 accent-orange text-white"
                                    />
                                  </div>
                                </div>

                                <h3 className="text-sm my-2 font-semibold text-gray-800 mb-2">
                                  {cls?.language} ({cls?.level_name})
                                </h3>
                                <div className="flex my-2 items-center text-md text-gray-700 mb-3">
                                  <FaChalkboardTeacher className="mr-2 text-sm" />
                                  {cls?.tutor}
                                </div>
                                <div className="flex my-2 flex-wrap gap-2 mb-3">
                                  {cls?.schedule?.map((time, idx) => (
                                    <span
                                      key={idx}
                                      className={`${cls?.theme?.chip} text-white px-3 py-1 text-xs rounded-full flex items-center`}
                                    >
                                      <BsCalendarDate className="mr-1 text-xs" />
                                      {time}
                                    </span>
                                  ))}
                                </div>

                                {/* <p className="text-sm my-2 text-gray-900 font-semibold">
                                  {cls?.currency}{cls?.amount} <span className="font-normal text-xs">/ session</span>
                                </p> */}
                              </div>
                            ) 
                          }
                      })}
                      </div>
                      ) : (
                        <div className='flex items-center justify-center h-[200px]'>
                          {userProfile?.sub_name == null ? (
                            <p className="text-sm text-[#db8e09] font-semibold">Select a child account to enroll for classes</p>
                          ): (
                            <p className="text-sm text-[#db8e09] font-semibold">There are no group classes available for {userProfile?.sub_name}'s age in this language</p>
                          )}
                        </div>
                      )}
                      </div>
                      )}
                    </div>
                </div>
            </main>
        </div>
    </div>
  );
}

export default EnrollScreen;
